import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SafeUrlPipe } from '../pipes/safe-url.pipe';
@Component({
  selector: 'app-file-viewer',
  standalone: true,
  imports: [CommonModule, SafeUrlPipe],
  templateUrl: './file-viewer.component.html',
  styleUrl: './file-viewer.component.scss'
})
export class FileViewerComponent implements OnInit {
  fileUrl: string = '';
  fileName: string = '';
  zoom: number = 1;
  zoomLevel: number = 1;
  translateX: number = 0;
  translateY: number = 0;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    // Assuming you read the URL params like this:
    this.route.queryParams.subscribe(params => {
      this.fileUrl = params['file'] || '';
      this.fileName = params['name'] || 'unknown';
    });

  }

  isPdfFile(): boolean {
    return this.fileUrl.toLowerCase().endsWith('.pdf');
  }

  zoomIn() {
    this.zoomLevel += 0.1;
  }

  zoomOut() {
    this.zoomLevel = this.zoomLevel > 0.2 ? this.zoomLevel - 0.1 : 0.2;
  }

  get zoomStyle(): string {
    return `scale(${this.zoomLevel}) translate(${this.translateX}px, ${this.translateY}px)`;
  }

  downloadFile() {
    const link = document.createElement('a');
    link.href = this.fileUrl;
    link.download = this.fileName;
    link.click();
  }
  
}
